import { useOptionalFilters } from "components/Elements/Filters/FilterContext";

// Returns a getter that produces the current page's filter state in the
// backend report-DTO shape. Each filter component populates its own
// reportParams (or falls back to .params); FilterContext.buildReportFilterContext
// spreads them. No filter-type knowledge lives here.
//
// Resilient when no FilterProvider is mounted (e.g. profile-edit flow):
// the returned getter just yields {}.
export const useReportFilterContext = () => {
	const ctx = useOptionalFilters();
	return ctx?.buildReportFilterContext ?? (() => ({}));
};
